import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import {
  SubmitBtn,
} from "../Styles/InputStyles";
import { Formik, Field, Form } from "formik";
//import Loading from "../Loading";
import Model from "../Model";
import { toast } from "react-toastify";

const UploadDocModel = ({ setShowUploadModel, docType, uploadDocMutate, isDocLoading}) => {
  const [file, setFile] = useState(null);
  const [message, setMessage]=useState("*Please select .jpg or .png or .jpeg or .pdf file below 2MB size.");
  const [errorMessage, setErrorMessage] = useState("");
  

const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        // Set an error message
        setErrorMessage("Please select an image below 2MB in size.");
        setFile(null); // Clear the file state
      } else {
            const tempFile = acceptedFiles.map((file) => {
              return Object.assign(file, {
                preview: URL.createObjectURL(file),
              });
            });

        setFile(tempFile);
        setErrorMessage(""); // Clear the error message
      }
    }
  }, []);

  
  const accept =
     ".jpg,.png,.jpeg,.pdf";
  const minSize = 0;
  const maxSize = 26214400;
  const maxFiles = 1;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    minSize,
    maxSize,
    maxFiles,
  });

  const removePreviewImage = () => setFile(null);
  
  const SubmitHandler = (values) => {
    // Include the imageFile data in the payload
    if (!file)
    {
      toast.error("Please select a file to upload");
      return;
    }
    const payload = {
      ...values,
      selectedDoc: file?.[0],
      };
    uploadDocMutate(payload);
  };
  return (
    <>
      <Model width={`w-11/12 max-w-lg`} setOpenModel={setShowUploadModel} title="Upload Document">
     
      <Message>{message}</Message>
      {!file && (
        <Uploader
          getRootProps={getRootProps}
          getInputProps={getInputProps}
          isDragActive={isDragActive}
          setS
          //componentFor={componentFor}
        />
      )}
      {file && (
        <FileName>
          {file[0].name}
          
          <PreviewFigure onClick={removePreviewImage} $admin={true}>
            <img src={Images.Cross} className="w-2" />
          </PreviewFigure>
        </FileName>
      )}
       {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
       {/* {isDocLoading &&<Loading/>} */}
         <Formik initialValues={{ type: docType }} onSubmit={SubmitHandler}>
          <Form>
            <input type="hidden" name="type" value={docType} />
            <BtnWrapper>
              <SubmitBtn type="submit" disabled={isDocLoading}>
              {isDocLoading ? "Uploading..." : "Upload"}
                </SubmitBtn>
            </BtnWrapper>
            
            </Form>
        </Formik>
       </Model>
       </>
  );
};

const Uploader = ({
  getRootProps,
  getInputProps,
  isDragActive,
  componentFor,
}) => (
  <div
    {...getRootProps()}
    className="w-full h-full bg-gray-50 rounded-md border-2 border-gray-200   "
  >
    <input {...getInputProps()} />

    <div
      className={`w-full h-full grid place-content-center p-3 ${
        isDragActive ? "bg-gray-300" : ""
      }`}
    >
      <Label htmlFor="file">
        <TextWrapper>
          <img src={Images.Upload} alt="upload-icon" className="w-5" />

          <p>
            {isDragActive
              ? "Drop it like it's hot"
              : `Click or Drag ${
                  "Image"
                } To Upload`}
          </p>
          {/* {componentFor === "profile" && <p>(JPG, PNG, JPEG )</p>} */}
        </TextWrapper>
      </Label>
    </div>
  </div>
);


const TextWrapper = tw.div`
${(p) => (p.$isDragActive ? "bg-gray-400" : " bg-gray-100")}
 upload-fonts w-full  rounded-lg  text-gray-600 flex flex-col items-center py-4 px-3 gap-0 mt-1 cursor-pointer md:text-xs md:gap-2 md:px-8 md:py-5
`;

const Label = tw.label`
text-sm text-gray-600`;

const PreviewFigure = tw.div`
${(p) => (p.$admin ? "top-2.5 right-2" : " -top-1  -right-1")}
w-5 h-5 rounded-full grid place-items-center cursor-pointer absolute bg-black`;

const FileName = tw.p` relative font-medium p-3 w-full bg-gray-100 rounded-md text-gray-500 text-sm`;
const ErrorMessage = tw.p`
  text-red-500
  text-sm
  mb-2
  mt-2
`;
const Message = tw.p`
  text-gray-800
  text-sm
  mb-2
  mt-2
`;
const BtnWrapper = tw.div`
  w-full flex items-center justify-center space-x-10 mt-8
`;
const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-start`;
export default UploadDocModel;
